module.exports = __webpack_public_path__ + "img/loader.e5c4edf0.svg";